import { render, staticRenderFns } from "./ClientResult.vue?vue&type=template&id=74409f90&scoped=true"
import script from "./ClientResult.vue?vue&type=script&lang=js"
export * from "./ClientResult.vue?vue&type=script&lang=js"
import style0 from "./ClientResult.vue?vue&type=style&index=0&id=74409f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74409f90",
  null
  
)

export default component.exports